import { z } from 'zod';
import { DecimalLikeSchema, EstadoSchema, IsoDateTimeSchema, NullableEmailSchema, NullableUrlSchema, UuidSchema, } from './common.js';
export const SucursalSchema = z.object({
    id: UuidSchema,
    nombre: z.string().min(1),
    tipo: z.string().nullable(),
    ciudad: z.string().nullable(),
    direccion: z.string().nullable(),
    telefono: z.string().nullable(),
    encargado: z.string().nullable(),
    lat: DecimalLikeSchema.nullable(),
    lng: DecimalLikeSchema.nullable(),
    clienteId: UuidSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
// Shape mínimo p/ dropdowns cross-módulo (F9): qualquer autenticado resolve
// id→nombre; sem direccion/telefono/encargado/coords.
export const SucursalOptionSchema = z.object({
    id: UuidSchema,
    nombre: z.string().min(1),
});
export const CreateSucursalRequestSchema = SucursalSchema.omit({
    id: true,
    createdAt: true,
});
export const UpdateSucursalRequestSchema = CreateSucursalRequestSchema.partial();
export const ClienteSchema = z.object({
    id: UuidSchema,
    nombre: z.string().min(1),
    ruc: z.string().nullable(),
    tipo: z.string().nullable(),
    contacto: z.string().nullable(),
    telefono: z.string().nullable(),
    email: NullableEmailSchema,
    direccion: z.string().nullable(),
    lat: DecimalLikeSchema.nullable(),
    lng: DecimalLikeSchema.nullable(),
    sucursalId: UuidSchema.nullable(),
    avatarUrl: NullableUrlSchema,
    createdAt: IsoDateTimeSchema.nullable(),
});
// Shape mínimo p/ dropdowns cross-módulo (F9): id/nombre apenas — sem RUC,
// montos, contato ou endereço.
export const ClienteOptionSchema = z.object({
    id: UuidSchema,
    nombre: z.string().min(1),
});
// avatarUrl é derivado server-side via upload (POST /:id/avatar); não aceitar no
// body de create/update evita mass-assignment de URL apontando para objeto alheio.
export const CreateClienteRequestSchema = ClienteSchema.omit({
    id: true,
    createdAt: true,
    avatarUrl: true,
});
export const UpdateClienteRequestSchema = CreateClienteRequestSchema.partial();
// Contrato (PDF) de um cliente. storagePath não é exposto: download via endpoint
// autenticado (GET /api/clientes/:id/contratos/:contratoId/download), bucket privado.
export const ContratoSchema = z.object({
    id: UuidSchema,
    clienteId: UuidSchema,
    fileName: z.string().nullable(),
    fileType: z.string().nullable(),
    fileSize: z.number().int().nonnegative().nullable(),
    uploadedBy: UuidSchema.nullable(),
    uploadedAt: IsoDateTimeSchema.nullable(),
});
export const CategoriaTipoSchema = z.enum(['ingreso', 'egreso']);
// tipo/estado usam `.catch` no parse de RESPOSTA: categorias migradas do legado têm
// valores fora do enum (`'Gasto General'`, `''`). Sem isso, listar "Todos" inclui essas
// linhas e o parse do array inteiro lança, zerando a tela. Coergir p/ null mantém a
// linha visível (renderiza `—`) em vez de quebrar a lista. O create/update mantém os
// campos estritos (override abaixo) — input não pode coergir silenciosamente.
export const CategoriaSchema = z.object({
    id: UuidSchema,
    nombre: z.string().min(1),
    descripcion: z.string().nullable(),
    tipo: CategoriaTipoSchema.nullable().catch(null),
    sucursalId: UuidSchema.nullable(),
    estado: EstadoSchema.nullable().catch(null),
    esCombustible: z.boolean().catch(false),
    createdBy: UuidSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreateCategoriaRequestSchema = CategoriaSchema.omit({
    id: true,
    createdAt: true,
    createdBy: true,
}).extend({
    nombre: z.string().min(1).max(80),
    tipo: CategoriaTipoSchema.nullable(),
    estado: EstadoSchema.nullable(),
    esCombustible: z.boolean().optional().default(false),
});
export const UpdateCategoriaRequestSchema = z.object({
    nombre: z.string().min(1).max(80).optional(),
    descripcion: z.string().nullable().optional(),
    tipo: CategoriaTipoSchema.nullable().optional(),
    sucursalId: UuidSchema.nullable().optional(),
    estado: EstadoSchema.nullable().optional(),
    esCombustible: z.boolean().optional(),
});
//# sourceMappingURL=catalog.js.map